import { render, staticRenderFns } from "./termsCondition.vue?vue&type=template&id=3571d976&scoped=true"
import script from "./termsCondition.vue?vue&type=script&lang=ts"
export * from "./termsCondition.vue?vue&type=script&lang=ts"
import style0 from "./termsCondition.vue?vue&type=style&index=0&id=3571d976&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3571d976",
  null
  
)

export default component.exports